import React, { useEffect } from "react";

// HubSpot Embed: https://js-na2.hs-scripts.com/243663191.js
function HubSpotChat() {
  useEffect(() => {
    // Ensure conversations load immediately in SPA context
    window.hsConversationsSettings = window.hsConversationsSettings || {
      loadImmediately: true,
    };

    if (document.getElementById("hs-script-loader")) return;
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = "hs-script-loader";
    script.async = true;
    script.defer = true;
    script.src = "https://js-na2.hs-scripts.com/243663191.js";
    document.head.appendChild(script);
  }, []);

  return null;
}

export default HubSpotChat;
